// extracted by mini-css-extract-plugin
export var copyableField = "_p0-4";
export var customerBadge = "_p0-0";
export var customerInfoTitle = "_p0-2";
export var details = "_p0-1";
export var dropdownContainer = "_p0-5";
export var dropdownImage = "_p0-6";
export var editAssigneeForm = "_p0-a";
export var editButton = "_p0-3";
export var email = "_p0-7";
export var hidden = "_p0-d";
export var input = "_p0-8";
export var saveButton = "_p0-b";
export var shopifyIcon = "_p0-c";
export var suggestionBadge = "_p0-e";
export var suggestionText = "_p0-f";
export var username = "_p0-9";